import type { NextPage } from 'next';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { GroupRvEnquiryForm } from '@/components/route/group-rv-bookings/EnquiryForm';
import { GroupRvFaqs } from '@/components/route/group-rv-bookings/FAQs';
import { GroupRvHero } from '@/components/route/group-rv-bookings/Hero';
import { GroupRvHowItWorks } from '@/components/route/group-rv-bookings/HowItWorks';
import { GroupRvResources } from '@/components/route/group-rv-bookings/Resources';
import { GroupRvTestimonial } from '@/components/route/group-rv-bookings/Testimonial';
import { DEFAULT_WHY_RV_CARDS, GroupRvWhyRVs } from '@/components/route/group-rv-bookings/WhyRVs';
import HeadMeta from '@/components/static-pages/HeadMeta';

const GroupRvBookingsPage: NextPage = () => {
  const intl = useIntl();

  const title = intl.formatMessage({
    id: 'F/h0T5',
    defaultMessage: 'Group RV rentals for events, workforces, and film productions.',
    description: 'Group bookings landing page SEO title',
  });

  const description = intl.formatMessage({
    id: '3PIURY',
    defaultMessage:
      'Need 5+ RVs for your event, film shoot, or corporate stay? Outdoorsy’s concierge team makes booking multiple RVs easy.',
    description: 'Group bookings landing page SEO description',
  });

  return (
    <>
      <HeadMeta title={title} description={description} />

      <main>
        {/* Hero */}
        <GroupRvHero
          eyebrow={
            <FormattedMessage
              id="Nf29/M"
              defaultMessage="Booking multiple RVs made easy."
              description="Group bookings hero eyebrow"
            />
          }
          headline={
            <FormattedMessage
              id="MhdNzO"
              defaultMessage="Group RV rentals for events, workforces, and film productions."
              description="Group bookings hero headline"
            />
          }
          body={
            <FormattedMessage
              id="xox3d9"
              defaultMessage="Need 5+ RVs for your event, film shoot, or corporate stay? We’re your dedicated, stress-free concierge service."
              description="Group bookings hero body copy"
            />
          }
        />

        {/* How it works */}
        <GroupRvHowItWorks />

        {/* Why RVs section */}
        <GroupRvWhyRVs
          heading={
            <>
              Why RVs are the smartest way to house <br />
              your cast, crew, or crowd.
            </>
          }
          cards={DEFAULT_WHY_RV_CARDS}
        />

        {/* FAQs */}
        <GroupRvFaqs />

        {/* Testimonial */}
        <GroupRvTestimonial isHomePage={true} />

        {/* Enquiry form (scroll target for CTAs above) */}
        <GroupRvEnquiryForm page="group-rv-bookings" />

        {/* Resources */}
        <GroupRvResources />
      </main>
    </>
  );
};

export default GroupRvBookingsPage;
